import ConfusedTouristsIntro from './ConfusedTouristsIntro';
import ConfusedTourists from './ConfusedTourists';
import ConfusedTouristsIntroGame from './ConfusedTouristsIntroGame';
import ConfusedTouristsOutro from './ConfusedTouristsOutro';

export default [ConfusedTouristsIntro, ConfusedTouristsIntroGame, ConfusedTourists, ConfusedTouristsOutro];
